import axios from "./axiosInstance";

const facilitiesAPI = {
  learning_labs: () => axios.get("learning-labs"),
  library: () => axios.get("library"),
  music_room: () => axios.get("music-room"),
  tuck_shop: () => axios.get("tuck-shop"),
  cctv_surveillance: () => axios.get("cctv-surveillance"),
  smart_classroom: () => axios.get("smart-classroom"),
  mid_day: ()  => axios.get("mid-day"),
  art_room: () => axios.get("art-room"),
  kyan_smart : () => axios.get("kyan-smart"),
  physical_education: () => axios.get("sport-physical"),
  medical_checkup : () => axios.get("medical-checkup"),
  
};

export default facilitiesAPI;
